import {PORTUGAL_UNLEASH_KEY} from '../../utils/constant';

import {Option, Select} from '@deere/fuel-react';
import {useFlag, useUnleashClient} from '@unleash/proxy-client-react';
import React from 'react';
import './LanguageSelect.css';

const LanguageSelect = ({languages, value, setValue}) => {
  const client = useUnleashClient();
  const isPortugalEnabled = useFlag(PORTUGAL_UNLEASH_KEY);
  const languageMap = {
    es: 'España',
    de: 'Deutschland',
    gb: 'United Kingdom',
    ...(isPortugalEnabled ? {pt: 'Portugal'} : {}),
  };

  const setSelectedCountry = (country) => {
    localStorage.setItem(`countryCode`, country);
    setValue(country);
    client.updateContext({country: country});
  };

  return (
    <Select
      id="language-select"
      data-testid="language-select"
      onChange={(e) => {
        setSelectedCountry(e.target.value);
      }}
      value={value}
    >
      {languages.map((item, index) => {
        return (
          <Option key={item} value={item}>
            <span id="faq-language-value">{languageMap[item]}</span>
          </Option>
        );
      })}
    </Select>
  );
};

export default LanguageSelect;
